module.exports = __webpack_public_path__ + "img/middleright2.cfad7987.png";